import { useState } from 'react';
import { useT } from '../i18n';
import { PROPOSALS } from './index';

// "Proposition nouvelle vue jalons/tâches" — showcase page grouping every
// proposal under review, one tab each. Access is limited to the proposals
// allow-list (App.tsx route gate + /api/proposals guard).
export function ProposalsPage() {
  const { t } = useT();
  const [activeId, setActiveId] = useState(PROPOSALS[0]?.id ?? '');
  const active = PROPOSALS.find(p => p.id === activeId) ?? PROPOSALS[0];

  return (
    <div className="page">
      <p className="text-sm text-ink-3 mb-16">{t('proposals.intro')}</p>

      {PROPOSALS.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-title">{t('proposals.emptyTitle')}</div>
          <div className="empty-state-desc">{t('proposals.emptyDesc')}</div>
        </div>
      ) : (
        <>
          <div className="toolbar mb-16">
            {PROPOSALS.map(p => (
              <button
                key={p.id}
                type="button"
                className={`chip ${p.id === active.id ? 'active' : ''}`}
                onClick={() => setActiveId(p.id)}
              >
                {t(p.titleKey)}
              </button>
            ))}
          </div>
          <p className="text-sm text-ink-2 mb-16">{t(active.summaryKey)}</p>
          <active.Component />
        </>
      )}
    </div>
  );
}
